<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Categories
					</div>
					<div class="card-body overflow-auto">
								<table class="table table-hover table-striped table-bordered">
									<thead>
										<tr>
											<th scope="col">Category</th>
											<th scope="col">Validity</th>
											<th scope="col">Manage</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="r in categories">
											<td>{{r.name}}</td>
											<td>{{r.validity}}</td>
											<td>
												<button class="btn btn-success fa fa-play" v-if="r.validity == 'Inactive'" @click="changeCategory(r.id)"></button>
												<button class="btn btn-danger fa fa-square" v-else-if="r.validity == 'Active'" @click="changeCategory(r.id)"></button>
											</td>
										</tr>
									</tbody>
								</table>
					</div>
					<div class="card-footer">
						<div class="row">
							<div class="form-group">
								<input type="text" placeholder="Enter category name" class="form-control" v-model="categoryname">
							</div>
							<div class="form-group">
								<button class="btn btn-primary" @click="addCategory">Add</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br>
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Sub Categories
					</div>
					<div class="card-body overflow-auto">
								<table class="table table-hover table-striped table-bordered">
									<thead>
										<tr>
											<th scope="col">Sub Category</th>
											<th scope="col">Category</th>
											<th scope="col">Manage</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="r in subcategories">
											<td>{{r.name}}</td>
											<td>{{r.gift_category.name}}</td>
											<td>{{r.validity}}</td>
											<td>
												<button class="btn btn-success fa fa-play" v-if="r.validity == 'Inactive'" @click="changeSubCategory(r.id)"></button>
												<button class="btn btn-danger fa fa-square" v-else-if="r.validity == 'Active'" @click="changeSubCategory(r.id)"></button>
											</td>
										</tr>
									</tbody>
								</table>
					</div>
					<div class="card-footer">
						<div class="row">
							<div class="form-group">
								<v-select v-model="category" :options="categories" label="name" :reduce="categories => categories.id" placeholder="Choose the category"></v-select>
							</div>
							<div class="form-group">
								<input type="text" placeholder="Enter sub category name" class="form-control" v-model="subcategoryname">
							</div>
							<div class="form-group">
								<button class="btn btn-primary" @click="addSubCategory">Add</button>
							</div>
						</div>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getCampaign();
        	this.getCategories();
        	this.getSubCategories();
        },
        
        data(){
        	return {
        		campaign: {},
        		categories: [],
        		subcategories: [],
        		categoryname: '',
        		category: '',
        		subcategoryname: ''
        	}
        },
        
        methods: {
        	getCampaign(){
        		axios.post("/api/getGiftCampaign", {id: this.$route.params.id})
        		.then(response => {
        			this.campaign = response.data;
        		});
        	},
        	
        	getCategories(){
        		axios.post("/api/getGiftCategories", {campaign: this.$route.params.id})
        		.then(response => {
        			this.categories = response.data;
        		});
        	},
        	
        	getSubCategories(){
        		axios.post("/api/getGiftSubCategories", {campaign: this.$route.params.id})
        		.then(response => {
        			this.subcategories = response.data;
        		});
        	},
        	
        	addCategory(){
        		axios.post("/api/addGiftCategory", {campaign: this.$route.params.id, name: this.categoryname})
        		.then(() => {
        			this.getCategories();
        		});
        	},
        	
        	addSubCategory(){
        		axios.post("/api/addGiftSubCategory", {campaign: this.$route.params.id, name: this.subcategoryname, category: this.category})
        		.then(() => {
        			this.getSubCategories();
        		});
        	},
        	
        	changeCategory(id){
        		axios.post("/api/changeGiftCategory", {id: id})
        		.then(() => {
        			this.getCategories();
        		});
        	},
        	
        	changeSubCategory(id){
        		axios.post("/api/changeGiftSubCategory", {id: id})
        		.then(() => {
        			this.getSubCategories();
        		});
        	}
        }
    }
</script>
